import { BrandName } from './Typescript'

let locationUrl = ''

export const isDevEnv = process.env.REACT_APP_CONFIG_ENV === 'dev' || false

export function getLocationUrl() {
    if (locationUrl == '') {
        const { protocol, host, pathname } = window.location
        const updatedPathName = pathname.split('').pop() == '/' ? pathname : `${pathname}/`
        locationUrl = `${protocol}//${host}${pathname == '/' ? '/' : `${updatedPathName}`}`
    }
    return locationUrl
}

export function getBrandName() {
    const isCNBC = getLocationUrl().includes('cnbc.com')
    return isCNBC ? BrandName.cnbc : BrandName.msnbc
}

export function wait(ms: number): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve()
        }, ms)
    })
}
